import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Paprika } from '../../../../styles/theme';

interface Props {
  minutes?: number | null;
}

export function TimeChip({ minutes }: Props) {
  if (!minutes) return null;
  const label = minutes < 60 ? `${minutes} min` : `${Math.floor(minutes / 60)}h${minutes % 60 ? String(minutes % 60).padStart(2, '0') : ''}`;
  return (
    <View style={styles.chip}>
      <Text style={styles.text}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  chip: {
    backgroundColor: Paprika.bgSunk,
    borderRadius: 999,
    paddingHorizontal: 8,
    paddingVertical: 2,
    alignSelf: 'flex-start',
  },
  text: {
    fontFamily: 'Inter-Regular',
    fontSize: 12,
    color: Paprika.textSecondary,
  },
});
